module.exports = __webpack_public_path__ + "img/crypto3.9987236b.png";